var _defs, _rect, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailNotificationsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Notification_32px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32.465,
    height: 32,
    viewBox: "0 0 32.465 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140294",
    "data-name": "Rectangle 140294",
    width: 31.301,
    height: 22.28,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_680",
    width: 32,
    height: 32,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M21.81,5.29a2.784,2.784,0,0,1,.06.58",
    fill: "#165cf3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161110",
    "data-name": "Group 161110",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83114",
    "data-name": "Path 83114",
    d: "M0,0H30V30H0Z",
    transform: "translate(1.814 2)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_161112",
    "data-name": "Group 161112",
    transform: "translate(1.164 5.86)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161111",
    "data-name": "Group 161111",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83115",
    "data-name": "Path 83115",
    d: "M2.172,17.576h0a.967.967,0,0,1-.82-.349c3.178-2.477,6.3-4.92,9.268-7.26.118-.093.126-.086.23-.008.624.468,1.265.932,1.886,1.38l.21.152a1.782,1.782,0,0,0,2.222,0l.245-.177c.609-.441,1.238-.9,1.852-1.352a.5.5,0,0,1,.079-.05.191.191,0,0,1,.06.038c.59.474,1.2.951,1.787,1.411l.638.5.2.154.13-.213c.032-.052.064-.1.1-.153a2.893,2.893,0,0,0,.238-.417.533.533,0,0,0-.1-.568c-.6-.481-1.244-.991-1.905-1.463a1.027,1.027,0,0,1-.083-.065c.02-.018.051-.043.1-.077,2.08-1.5,4.189-3.036,6.229-4.52l2.053-1.493V5.06c0,1.308,0,2.661.005,3.992a.79.79,0,0,0,.232.592,2.152,2.152,0,0,0,.512.246c.068.026.137.051.206.081l.309.131V9.766q0-1,0-2c0-1.95,0-3.966-.008-5.946a1.672,1.672,0,0,0-.622-1.3A2.314,2.314,0,0,0,25.878,0h0L8.391,0H2.562L2.371,0a4.772,4.772,0,0,0-.5.009A1.727,1.727,0,0,0,.155,1.319,4.369,4.369,0,0,0,.018,2.371C0,7.449,0,12.547,0,16.864a2.291,2.291,0,0,0,.083.636,1.988,1.988,0,0,0,1.99,1.339h0l15.012,0h.367c.1,0,.208,0,.313-.008a.472.472,0,0,0,.381-.231c.079-.163.146-.331.216-.509.027-.069.055-.14.085-.214l.124-.306H14.724c-4.114,0-8.368,0-12.552.007M1.4,1.523a.325.325,0,0,1,.056-.035,1.7,1.7,0,0,1,.73-.207c3.17-.012,6.394-.011,9.512-.01h4.331c3.2,0,6.5,0,9.756.011a1.836,1.836,0,0,1,.79.241.262.262,0,0,1,.058.038.36.36,0,0,1-.1.091c-1.049.737-2.284,1.609-3.491,2.489-.963.7-1.937,1.423-2.878,2.119q-1,.74-2,1.477c-.825.606-1.668,1.22-2.482,1.812l-1.165.848c-.4.289-.523.291-.906.013q-3.847-2.8-7.69-5.6L4.061,3.464q-.373-.272-.745-.546c-.6-.439-1.216-.894-1.837-1.324A.441.441,0,0,1,1.4,1.523M9.6,9.059c.03.021.051.038.067.051-.013.012-.031.027-.054.045-.534.416-1.071.845-1.591,1.261s-1.081.865-1.627,1.289c-.52.4-1.057.807-1.576,1.2s-1.027.77-1.535,1.164c-.54.419-1.062.845-1.615,1.3l-.391.319V3.015L2.5,3.9,6.2,6.59l1.05.765C8.022,7.915,8.818,8.5,9.6,9.059",
    transform: "translate(0 0)",
    fill: "#9526dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83116",
    "data-name": "Path 83116",
    d: "M265.606,136.68a1.182,1.182,0,0,1-1.331.957c-.915,0-1.841,0-2.753,0a.311.311,0,0,1-.046.165,2.292,2.292,0,0,1-1.343,1,2.358,2.358,0,0,1-.662.094,2.449,2.449,0,0,1-2.018-1.062c-.036-.054-.066-.108-.1-.171l-.013-.023h-.311c-.805,0-1.619,0-2.424-.01a1.78,1.78,0,0,1-.888-.214,1.169,1.169,0,0,1-.6-.891,1.367,1.367,0,0,1,.532-1.128,3.021,3.021,0,0,0,.944-1.941c.077-.519.111-1.058.145-1.58.024-.388.05-.79.093-1.185a3.978,3.978,0,0,1,2.255-3.249l.048-.025a1.35,1.35,0,0,1,.3-.128l.058-.014c.282-.069.388-.095.425-.381a1.209,1.209,0,0,1,1.324-.938,2.659,2.659,0,0,1,1.08.22,1.248,1.248,0,0,1,.559.815c.036.191.059.2.179.225a3.729,3.729,0,0,1,2.3,1.7,4.587,4.587,0,0,1,.65,2.251c.009.137.007.273.007.4a4.072,4.072,0,0,0,.011.44c.016.167.03.334.042.5a8.736,8.736,0,0,0,.2,1.469,2.772,2.772,0,0,0,.9,1.423,1.179,1.179,0,0,1,.434,1.271",
    transform: "translate(-234.352 -116.62)",
    fill: "#0ee359"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailNotificationsIcon);
export default __webpack_public_path__ + "static/media/email-notifications-icon.5294a102b5249e387a526db3792d2a75.svg";
export { ForwardRef as ReactComponent };